/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type MainContactResponseDto = {
    /**
     * Unique identifier for the main contact
     */
    id: string;
    /**
     * Preferred name for the main contact
     */
    preferredName?: string | null;
    /**
     * Last name of the main contact
     */
    lastName?: string | null;
    /**
     * Email address of the main contact
     */
    email?: string | null;
    /**
     * Preferred phone type for communication
     */
    preferredPhone?: MainContactResponseDto.preferredPhone | null;
    /**
     * Mobile phone number
     */
    mobile?: string | null;
    /**
     * Home phone number
     */
    homePhone?: string | null;
    /**
     * Work phone number
     */
    workPhone?: string | null;
    /**
     * External reference ID from another system
     */
    externalReference?: string | null;
    /**
     * Creation timestamp
     */
    createdAt: string;
    /**
     * Last update timestamp
     */
    updatedAt: string;
};
export namespace MainContactResponseDto {
    /**
     * Preferred phone type for communication
     */
    export enum preferredPhone {
        MOBILE = 'MOBILE',
        HOME = 'HOME',
        WORK = 'WORK',
    }
}

